<template>
  <div style="display: inline-block;" v-if="sellerStatus > 4">
    <TheButton text="Editar Tracking" @click="openEditTracking()" icon:="mdi-truck" css="mr-1" />

    <TheDialog icon="mdi-truck-fast" title="Editar Tracking" v-model="editTracking" width="400px">
      <template>
        <v-form v-model="valid" ref="form">
          <b>Código de Rastreio</b>
          <v-text-field
            class="mt-1"
            placeholder="Código de Rastreio"
            v-model="trackingObject.orderTracking"
            outlined
            dense
            color="primary"
            :rules="[requireRule]"
            autofocus
          ></v-text-field>
          <b>Url de Rastreio</b>
          <v-text-field
            class="mt-1"
            placeholder="Url de Rastreio"
            v-model="trackingObject.orderTrackingUrl"
            outlined
            dense
            color="primary"
            :rules="[requireRule]"
          ></v-text-field>
          <b>Transportadora</b>
          <v-text-field
            class="mt-1"
            placeholder="Transportadora"
            v-model="trackingObject.orderCarrier"
            outlined
            dense
            color="primary"
            :rules="[requireRule]"
          ></v-text-field>
          <b>Data de Envio</b>
          <v-text-field
            class="mt-1"
            placeholder="Data de Envio"
            v-model="trackingObject.orderSendDate"
            outlined
            dense
            color="primary"
            :rules="[requireRule]"
            v-mask="'##/##/####'"
            append-inner-icon="mdi-calendar"
          ></v-text-field>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" dark block depressed @click="sendTrackNfe()">
          <v-icon class="mr-1" small>mdi-check</v-icon>
          Salvar Tracking
        </v-btn>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { mask } from 'vue-the-mask'
import { formatStringData } from '@/plugins/generic.js'
import TheButton from '@/components/TheButton'
import TheDialog from '@/components/TheDialog'

export default {
  directives: { mask },
  components: {
    TheButton,
    TheDialog,
  },
  props: {
    tracking: Object,
    sellerStatus: Number,
    date: String,
    orderId: Number,
  },
  data: () => ({
    trackingObject: {},
    editTracking: false,
    valid: false,
    requireRule: (v) => !!v || 'Campo obrigatório',
  }),
  methods: {
    formatStringData,
    openEditTracking() {
      this.editTracking = true
    },
    sendTrackNfe() {
      this.$refs.form.validate()
      if (!this.valid) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'É preciso preencher todos os campos do tracking',
          button: 'Ok!',
        })
        return false
      }
      const url = `${baseApiUrl}/order/tracking/${this.orderId}`
      const orderAuthorizedDate = new Date(this.date)//.setHours(0, 0, 0, 0)
      const orderSendDate = new Date(this.formatStringData(this.trackingObject.orderSendDate))//.setHours(0, 0, 0, 0)
      orderAuthorizedDate.setHours(0, 0, 0, 0)
      orderSendDate.setHours(0, 0, 0, 0)

      console.log(orderAuthorizedDate, orderSendDate)
      if (orderSendDate < orderAuthorizedDate) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Data de postagem não pode ser uma data menor que a data de aprovação',
          button: 'Ok!',
        })
        return false
      }
      
      axios
        .post(url, this.trackingObject)
        .then(() => {
          this.trackingObject = {}
          this.editTracking = false
        })
        .catch(showError)
        .finally((this.editTracking = false))
    },
  },
  mounted() {
    this.trackingObject = this.tracking
  },
}
</script>
